<template>
  <!-- <Dialog v-model:visible="showDialog" :modal="true" :header="$t('group.title')"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }"> -->
  <Dialog
    :modal="true"
    v-model:visible="showDialog"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    :header="model ? $t('group.Edittitle') : $t('group.title')"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              :required-icon="true"
              id=""
              name="code"
              :label="$t('group.code')"
              :rules="{ required: true }"
              v-model="Groupform.Code"
              type="text"
              placeholder=" "
              disabled
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="true"
              id="Item Group Name"
              name="Item Group Name"
              :label="$t('group.name')"
              :rules="{ required: true }"
              v-model="Groupform.Name"
              type="text"
              placeholder=" "
              case="Capital"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" class="addcircle_field">
          <div class="field">
            <CustomDropdown
              :required-icon="true"
              :label="$t('group.Mapping')"
              :rules="{ required: true }"
              v-model="Groupform.ParentId"
              :items="category.categoryoption"
              @update:value=""
              id="Item mapping"
              name="Item mapping"
            />
            <!-- <span class="float-end blue-txt mt-3" @click="IsAddCategory">+ Add Category</span> -->
          </div>
          <span class="add_circle" @click="IsAddCategory"
            ><i class="pi pi-plus"></i
          ></span>
        </b-col>
      </b-row>
      <Footer
        @cancel="(showDialog = false), IsClear()"
        :cancelhide="false"
        :label="label"
        :loading="Saveloader"
      />
    </b-form>
  </Dialog>
  <CategoryCreation
    v-if="DialogShow.Category"
    @load="categorydropdownapi(), (DialogShow.Category = false)"
    @close="DialogShow.Category = false"
    @loaderhide="loading = false"
    @loadershow="loading = true"
    :OperationID="ObjOperationId"
    :EntityId="EntityIds.Category"
  />

  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsEdit()"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import GroupService from "../../../../../../modules/Inventory/Service/GroupService";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import CategoryService from "../../../../../../modules/Inventory/Service/CategoryService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import moment from "moment";
import CategoryCreation from "../../../Masters/ItemCategory/CategoryMaster/CategoryCreation.vue";
import MastersService from "../../../../Service/MastersService";
import { checkPermission } from "../../../../Service/AccessControl";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AlreadyExist,
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    TextField,
    CustomDropdown,

    Footer,
    CategoryCreation,
  },
  setup(props, { emit }) {
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    let loading = ref(false);
    let Saveloader = ref(false);
    const toast = useToast();
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    const label = ref(t("btn.save"));

    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      Category: false,
    });
    let EntityIds = ref({
      Category: 106,
    });

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        IsSubmit();
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      // showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
      // else if (event.key == 'e') {
      // IsEdit()
      // }
      // else if (event.key == 'Escape') {

      // IsClear()
      // }
    }
    //Table data Variable
    let items = ref([]);
    //update and create jsonrequest

    //Request form
    const Groupform = ref({
      Id: 0,
      Name: "",
      Code: "",
      ParentId: ref(),
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
    });

    //Editable
    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");

      try {
        label.value = "Update";
        let Id = model.value.Id;
        const response = await GroupService.getfindonedata(Id);
        let data = response["result"];
        Object.keys(Groupform.value).forEach((key) => {
          if (data[key]) Groupform.value[key] = data[key];
        });
        category.value.categoryId = data.Id;
        Editmodel.value = false;
        emit("loaderhide");

        // showDialog.value = true;
      } catch (error) {
        showDialog.value = false;
        emit("loaderhide");
        alert(error);
      }
    }
    //Submit Function
    const IsSubmit = async () => {
      debugger;
      emit("loadershow");
      Saveloader.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      try {
        Groupform.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        Groupform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        Groupform.value.BranchId = BranchId;
        Groupform.value.HospitalId = HospitalId;
        Groupform.value.ModifiedBy = UserId;
        Groupform.value.CreatedBy = UserId;
        Groupform.value.EntityId = Number(Entitydata.value.EntityId);

        console.log(Groupform.value.ParentId);
        if (Groupform.value.Id != 0) {
          Groupform.value.EntityOperationId = props.OperationID.UpdateId;
          const response = await GroupService.updatedata(Groupform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            emit("loaderhide");
            Saveloader.value = false;
            resetField("Item Group Name");
            alreadyexistpop.value = true;
          } else if (message == null) {
            emit("loaderhide");
            Saveloader.value = false;
            updatepop.value = true;
          } else {
            Saveloader.value = false;
            alert("something went wrong");
          }
        } else {
          Groupform.value.EntityOperationId = props.OperationID.CreateId;
          const response = await GroupService.createdata(Groupform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            emit("loaderhide");
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            emit("loaderhide");
            Saveloader.value = false;
            successpop.value = true;
          } else {
            Saveloader.value = false;
            alert("something went wrong");
          }
        }
        // showDialog.value = false
        // emit('load')
        // IsClear();
      } catch (error) {
        emit("loaderhide");
        alert(error);
        Saveloader.value = false;
      }
    };
    //Clear Function
    const copydataModel = JSON.parse(JSON.stringify(Groupform.value));
    const copySelectOption = JSON.parse(JSON.stringify(Groupform.value));

    const IsClear = () => {
      Object.assign(Groupform.value, copydataModel);
      Object.assign(category.value.categoryoption, copySelectOption);
      emit("update:selectedItem", undefined);
      emit("close");
    };
    //Category dropdown
    const category = ref({
      categoryId: null,
      categoryoption: [],
    });

    //Category dropdown Api Call
    async function categorydropdownapi() {
      debugger;
      try {
        debugger;
        const response = await CategoryService.getdata();
        items.value = response["result"].reverse();
        console.log(items.value);
        category.value.categoryoption = response["result"]
          .filter(
            (items) => items.HospitalId == HospitalId && items.Status == true
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        //FormId: 23,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      Groupform.value.Code = result;
      if (result) {
        showDialog.value = true;
      }
    }
    async function IsEditpop() {
      Editmodel.value = true;
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    const alreadyexistpop = ref(false);

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      Groupform.value.Name = ""; //showDialog.value = true
    }

    function IsAddCategory() {
      FunctionRights(EntityIds.value.Category, "Category");
    }
    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    return {
      Saveloader,
      model,
      EntityIds,
      IsAddCategory,
      DialogShow,
      alreadyclosetrigger,
      alreadyexistpop,
      IsEditpop,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      IsEdit,
      IsCreate,
      showDialog,
      IsClear,
      Groupform,
      items,
      category,
      categorydropdownapi,
      IsSubmit,
      GetCode,
      label,
      ObjOperationId,
      loading,
    };
  },
  created() {
    this.categorydropdownapi();
  },
});
</script>
